import { render, staticRenderFns } from "./TripRoute.vue?vue&type=template&id=0978824c"
import script from "./TripRoute.vue?vue&type=script&lang=js"
export * from "./TripRoute.vue?vue&type=script&lang=js"
import style0 from "./TripRoute.vue?vue&type=style&index=0&id=0978824c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports